<div class="MainBg">
  <div>
    <table id="ReportTable" class="CommonTable ClsReportTable w-100">
      <thead>
        <tr>
          <th>SR No.</th>
          <th>
            <span *ngIf="AmcMAsterArr.length > 0" (change)="SelectDeselect()">
              <!-- <label class="switch"> -->
              <input type="checkbox" />
              <!-- <span class="slider round"></span>
        </label> -->
            </span>
          </th>
          <th>AMC Name</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let AMC of AmcMAsterArr; let i = index">
          <td>{{ i + 1 }}</td>
          <td>
            <span
              *ngIf="AmcMAsterArr.length > 0"
              (change)="Active_InActivestatus(AMC.AMCCode)">
              <!-- <label class="switch"> -->
              <input
                type="checkbox"
                [checked]="AMC.status == 0 ? false : true" />
              <!-- <span class="slider round"></span>
    </label> -->
            </span>
          </td>
          <td>{{ AMC.AMCName }}</td>
        </tr>
      </tbody>
    </table>
    <br />
    <div class="SubmitMarginTop">
      <button
        class="CommonSubmitButton"
        (click)="OnSubmit()"
        [disabled]="AmcMAsterArr == ''">
        Submit
      </button>
    </div>
  </div>
</div>
